export default __webpack_public_path__ + "static/media/Uae_assessment_booked.aab23e47.svg";